/**
 * Agent 执行器基础设施的 Vue 注入键。
 * App.vue 创建单例并 provide；各页面视图 inject 注册能力。
 */
import type { InjectionKey } from "vue";
import type { AgentCapabilityRegistry } from "@/agent/AgentCapabilityRegistry";
import type { AgentCommandExecutor } from "@/agent/AgentCommandExecutor";

export const AGENT_REGISTRY_KEY: InjectionKey<AgentCapabilityRegistry> =
  Symbol("agent-registry");

export const AGENT_EXECUTOR_KEY: InjectionKey<AgentCommandExecutor> =
  Symbol("agent-executor");
